import RecepMenu from "../../components/Reception/RecepMenu/RecepMenu";
import "./reception.scss";
import StudentInfo from '../../components/Reception/Student/StudentInfo/StudentInfo';
import StudentRegister from '../../components/Reception/Student/StudentRegister/StudentRegister';
import React, { useState, useEffect, useRef } from "react";
// import SuccessRegister from "./Student/StudentRegister/SuccessRegister";
import ClassroomsGroups from "../../components/Reception/Groups/GroupsList";
//Axios
import Axios from 'axios';
//navigate
import { useNavigate } from "react-router-dom";
//User session
import { UserContext } from "../../context/userProvider";
import { dataDecrypt } from "../../utils/dataDecrypt";
//Formats
import PrintFormat from "../../components/Reception/Formats/printFormat"
import PaymentReceipt from "../../components/Reception/Payments/PaymentReceipt/PaymentReceipt";
import ExchangeRateRegister from "../../components/Reception/Payments/ExchangeRate/ExchangeRateRegister";
import CashAudit from "../../components/Reception/Payments/CashAudits/CashAudit";
import StudentDebts from "../../components/Reception/Payments/StudentDebts/StudentDebts";
import { GetSchoolingList, GetRelatedTypeList, GetSurveyOptions, GetSubsidiaryList, GetAcademicCalendar, GetAllTeacherClasses, GetExemptWeeks, GetLevelList } from "../../utils/Apis/apis";
import { getLocalDateString } from '../../utils/dateTimeZone'
import { GetReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary } from "../../utils/Apis/receptionApis";
import { useSubsidiarySession } from "../../context/sessionSubsidiaryProvider";
import { dataEncrpt } from "../../utils/dataEncrypt";
import ConfirmModal from "../../components/ConfirmModalV3/confirmModal";
import TeachersFollowUp from "../../components/Reception/Groups/TeachersFollowUp/TeachersFollowUp";
const Reception = () => {
    const { subsidiarySession } = useSubsidiarySession();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const receptionlistRegisterSCache = useRef({})
    const menuRef = useRef(null);
    const [user, setUser] = React.useContext(UserContext);
    //Alert
    const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
    const [modalHandlers, setModalHandlers] = useState({
        handleAccept: () => { },
        handleCancel: () => { },
    });
    const [modalDetailAction, setModalDetailAction] = useState('')
    const [modalTitleAction, setModalTitleAction] = useState('')
    const [cashAuditTotal, setCashAuditTotal] = useState(null);
    //State from studentDebts
    const [paymentStudentData, setPaymentStudentData] = useState(null);

    var sessionStorageArray = [];
    //select list variables
    const [dataLists, setDataLists] = useState({
        schoolingList: [],
        genreList: [
            { value: 1, label: 'Hombre' },
            { value: 2, label: 'Mujer' }
        ],
        scholarshipList: [
            { value: '', label: 'No asignar beca' },
            { value: 1, label: 'Beca completa' },
            { value: 2, label: 'Beca 50%' }
        ],
        relatedList: [],
        allTeacherClassesList: [],
        surveyOptionsList1: [],
        surveyOptionsList2: [],
        subsidiaryList: [],
        specialDateList: [],
        exemptWeeks: [],
        levelUnitList: []

    });

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleMenuClick = () => {
        setMenuOpen(!menuOpen);
    };

    const handleMenuItemClick = (item) => {
        if (item.status === "disabled") {
            return;
        }

        if (item.link && item.link !== "#") {
            window.open(item.link, "_blank", "noopener,noreferrer");
            return;
        }

        setSelectedComponent(item.name);
        setMenuOpen(false);
    };

    const handleCloseComponent = () => {
        setSelectedComponent(null); // Regresa al estado inicial sin componentes visibles
    };
    //LIST
    useEffect(() => {
        const fetchSubsidiaryFast = async () => {
            try {
                // ⚡ 1. Intentar cache primero
                const cached = localStorage.getItem('subsidiaryListCache');
                if (cached) {
                    setDataLists(prev => ({
                        ...prev,
                        subsidiaryList: JSON.parse(cached)
                    }));
                }

                // ⚡ 2. Fetch real (no bloquea UI)
                const response = await GetSubsidiaryList();

                if (response.auth === false) {
                    localStorage.clear();
                    navigate("/login");
                    return;
                }

                const subsidiaryList = response.result.map(e => ({
                    value: e.id,
                    label: e.name,
                    classrooms: e.classrooms,
                    info: e.info
                }));

                setDataLists(prev => ({
                    ...prev,
                    subsidiaryList
                }));

                localStorage.setItem(
                    'subsidiaryListCache',
                    JSON.stringify(subsidiaryList)
                );

            } catch (error) {
                console.error("Error loading subsidiary list", error);
            }
        };

        fetchSubsidiaryFast();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [
                    schoolingResponse,
                    relatedResponse,
                    teacherClassesResponse,
                    survey1Response,
                    survey2Response,
                    academicCalendarResponse,
                    exemptWeeksResponse,
                    levelUnitResponse,
                ] = await Promise.all([
                    GetSchoolingList(),
                    GetRelatedTypeList(),
                    GetAllTeacherClasses(),
                    GetSurveyOptions(1),
                    GetSurveyOptions(2),
                    GetAcademicCalendar(),
                    GetExemptWeeks(),
                    GetLevelList(),
                ]);

                if (
                    schoolingResponse.auth === false ||
                    relatedResponse.auth === false ||
                    teacherClassesResponse.auth === false ||
                    survey1Response.auth === false ||
                    survey2Response.auth === false ||
                    academicCalendarResponse.auth === false ||
                    exemptWeeksResponse.auth === false ||
                    levelUnitResponse.auth === false
                ) {
                    localStorage.clear();
                    navigate("/login");
                    return;
                }

                const lists = {
                    schoolingList: schoolingResponse.result.map(e => ({ value: e.id, label: e.name })),
                    relatedList: relatedResponse.result.map(e => ({ value: e.id, label: e.name })),
                    allTeacherClassesList: teacherClassesResponse.teacherClasses.map(e => ({
                        value: e.id,
                        id: e.id,
                        label: `Grupo #${e.id} / ${e.teacher.name || 'Maestro no asignado'} / ${e.is_online === true || e.is_online === 1 || e.is_online === '1' ? 'Online' : 'Presencial'} / ${e.full_dayclass} / ${e.level.name}`,
                        detail_class: {
                            teacher: { id: e.teacher.id, name: e.teacher.name },
                            class_day: e.class_day,
                            time: { start: e.time.start, end: e.time.end },
                            level: { id: e.level.id, name: e.level.name },
                            date: { start: e.date.start },
                            subsidiary: e.subsidiary,
                            is_online: e.is_online,
                            type_class: e.type_class,
                            is_finished: e.is_finished,
                            st: e.st
                        }
                    })),
                    surveyOptionsList1: survey1Response.result.map(e => ({ value: e.id, label: e.option })),
                    surveyOptionsList2: survey2Response.result.map(e => ({ value: e.id, label: e.option })),
                    specialDateList: academicCalendarResponse.result.map(e => ({
                        name: e.date_type_name,
                        date_start: e.date_start,
                        date_end: e.date_end
                    })),
                    exemptWeeks: exemptWeeksResponse.result.map(e => ({
                        id: e.id,
                        week: e.week,
                        year: e.year
                    })),
                    levelUnitList: {
                        adultList: levelUnitResponse.result.adults.map(element => ({
                            value: element.id,
                            label: element.name,
                            units: element.units
                        })),
                        // Asegúrate de conservar childrenList para que no se pierda su valor
                        childrenList: levelUnitResponse.result.kids.map(element => ({
                            value: element.id,
                            label: element.name,
                            units: element.units
                        })),
                    },
                };

                setDataLists(prev => ({ ...prev, ...lists }));

                const today = getLocalDateString();
                localStorage.setItem("receptionDataDateToRefresh", today);
                localStorage.setItem("receptionDataListsToRefresh", JSON.stringify(lists));

            } catch (error) {
                console.error("Error fetching secondary lists", error);
            }
        };

        const lastFetchDate = localStorage.getItem("receptionDataDateToRefresh");
        const today = getLocalDateString();

        if (lastFetchDate === today) {
            const cached = localStorage.getItem("receptionDataListsToRefresh");
            if (cached) {
                setDataLists(prev => ({ ...prev, ...JSON.parse(cached) }));
                return;
            }
        }

        fetchData();
    }, []);
    useEffect(() => {
        if (!localStorage.getItem("user")) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("receptionSubsidiarySession")
            localStorage.removeItem('receptionDataDateToRefresh')
            localStorage.removeItem('receptionDataListsToRefresh')
            localStorage.removeItem('alarmToCashAudit');
            localStorage.removeItem('cashAuditLastAlert');
            localStorage.removeItem('cashAuditLimitCrossed');

        }
        Axios.get(process.env.REACT_APP_API_URL + "isUserAuth/", {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        }).then((response) => {
            if (response.data.auth === false) {
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                localStorage.removeItem("receptionSubsidiarySession")
                localStorage.removeItem('receptionDataDateToRefresh')
                localStorage.removeItem('receptionDataListsToRefresh')
                localStorage.removeItem('alarmToCashAudit');
                localStorage.removeItem('cashAuditLastAlert');
                localStorage.removeItem('cashAuditLimitCrossed');
                navigate("/login");
            } else {
                if (Object.keys(user).length === 0) {
                    var userStorage = localStorage.getItem("user");
                    var userJson = dataDecrypt(userStorage);
                    setUser(userJson);
                    var checkAuth = false;
                    sessionStorageArray = dataDecrypt(localStorage.getItem("session"));
                    sessionStorageArray.forEach((e) => {
                        if (userJson.id === e.id) {
                            checkAuth = true;
                        }
                    });
                    if (
                        (userJson.idPriv.toString() !==
                            process.env.REACT_APP_API_RECEPCION_PRIVILEGE &&
                            userJson.idPriv.toString() !==
                            process.env.REACT_APP_API_DIRECCION_PRIVILEGE &&
                            userJson.idPriv.toString() !==
                            process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE) ||
                        checkAuth !== true
                    ) {
                        navigate("/login");
                    }

                } else {
                    var checkAuth = false;
                    sessionStorageArray = dataDecrypt(localStorage.getItem("session"));
                    sessionStorageArray.forEach((e) => {
                        if (user.id === e.id) {
                            checkAuth = true;
                        }
                    });
                    if (
                        (user.idPriv.toString() !==
                            process.env.REACT_APP_API_RECEPCION_PRIVILEGE &&
                            user.idPriv.toString() !==
                            process.env.REACT_APP_API_DIRECCION_PRIVILEGE &&
                            user.idPriv.toString() !==
                            process.env.REACT_APP_API_SUPERADMIN_PRIVILEGE) ||
                        checkAuth !== true
                    ) {
                        navigate("/login");
                    }

                }
            }
        });
    }, []);

    useEffect(() => {
        if (!subsidiarySession || !user?.employee_id) return;

        // 🚫 Si ya existe, no ejecutar
        if (localStorage.getItem('alarmToCashAudit')) return;

        const fetchCashAudit = async () => {
            const CashAuditVerify =
                await GetReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary(
                    subsidiarySession,
                    user.employee_id
                );
            if (CashAuditVerify.status === 200) {
                const totalReceived = CashAuditVerify.summary.cash_mxn + CashAuditVerify.summary.usd_to_mxn;
                localStorage.setItem('alarmToCashAudit', dataEncrpt(totalReceived));
                setCashAuditTotal(totalReceived)

            }
        };

        fetchCashAudit();
    }, [subsidiarySession, user?.employee_id]);

    const showModal = (total) => {
        setModalTitleAction('Corte de caja requerido');
        setModalDetailAction(
            `Se ha alcanzado un total de $${total.toLocaleString('es-MX')} MXN.\n` +
            `Es necesario realizar el corte de caja para continuar.`
        );

        setModalHandlers({
            handleAccept: () => {
                setSelectedComponent('Corte de caja');
                renderSelectedComponent();
                setIsModalConfirmOpen(false);
            },
            handleCancel: () => setIsModalConfirmOpen(false),
        });

        setIsModalConfirmOpen(true);
    };
    useEffect(() => {
        const CHECK_TIME = 10 * 60 * 1000;
        // 🔥 EJECUTAR CUANDO CAMBIA EL TOTAL (primer cruce)
        checkCashAuditAlarm();

        // 🔁 REPETIR POR TIEMPO
        const intervalId = setInterval(checkCashAuditAlarm, CHECK_TIME);
        return () => clearInterval(intervalId);

    }, [cashAuditTotal, isModalConfirmOpen]);

    const checkCashAuditAlarm = (forcedTotal) => {
        const encryptedTotal = localStorage.getItem('alarmToCashAudit');
        const total = forcedTotal ?? Number(dataDecrypt(encryptedTotal) || 0);

        if (total < 4500) return;

        const crossed = localStorage.getItem('cashAuditLimitCrossed');
        const lastAlert = Number(localStorage.getItem('cashAuditLastAlert') || 0);
        const now = Date.now();

        // 🚨 PRIMER CRUCE → inmediato
        if (crossed && !lastAlert) {
            showModal(total);
            localStorage.setItem('cashAuditLastAlert', now);
            return;
        }

        // ⏱️ siguientes alertas → por tiempo
        if (now - lastAlert < 10 * 60 * 1000) return;
        if (isModalConfirmOpen) return;

        showModal(total);
        localStorage.setItem('cashAuditLastAlert', now);
    };

    useEffect(() => {
        const handler = (e) => {
            checkCashAuditAlarm(e.detail?.total);
        };

        window.addEventListener('cash-audit-updated', handler);
        return () => window.removeEventListener('cash-audit-updated', handler);
    }, []);





    const renderSelectedComponent = () => {
        if (selectedComponent) {
            switch (selectedComponent) {
                case 'Registrar alumno':
                    return <StudentRegister onClose={handleCloseComponent} list={dataLists} usr={user} receptionlistRegisterSCache={receptionlistRegisterSCache} />;
                case 'Info alumno':
                    return <StudentInfo onClose={handleCloseComponent} list={dataLists} usr={user} />;
                case 'Listado de grupos':
                    return <ClassroomsGroups onClose={handleCloseComponent} listSubsidiary={dataLists.subsidiaryList} usr={user} />;
                case 'Diplomas y Constancias':
                    return <PrintFormat onClose={handleCloseComponent} isOpen={true} usr={user} listSubsidiary={dataLists.subsidiaryList} />;
                case 'Recibo de pago':
                    return <PaymentReceipt onClose={handleCloseComponent} isOpen={true} usr={user} listSubsidiary={dataLists.subsidiaryList} specialDateList={dataLists.specialDateList} exemptWeeks={dataLists.exemptWeeks} levelUnitList={dataLists.levelUnitList} paymentStudentData={paymentStudentData} setPaymentStudentData={setPaymentStudentData} />;
                case 'Tipo de cambio':
                    return <ExchangeRateRegister onClose={handleCloseComponent} isOpen={true} />
                case 'Corte de caja':
                    return <CashAudit onClose={handleCloseComponent} isOpen={true} usr={user} listSubsidiary={dataLists.subsidiaryList} />
                case 'Lista de adeudos':
                    return <StudentDebts onRedirectToPayment={redirectToPayment} onClose={handleCloseComponent} isOpen={true} listSubsidiary={dataLists.subsidiaryList} usr={user} specialDateList={dataLists.specialDateList} exemptWeeks={dataLists.exemptWeeks} />
                case 'Seguimiento de maestros':
                    return <TeachersFollowUp onClose={handleCloseComponent} isOpen={true} usr={user} listSubsidiary={dataLists.subsidiaryList}/>
                default:
                    return <div></div>;
            }
        }
    };

    const redirectToPayment = (studentData) => {
        setPaymentStudentData(studentData);
        setSelectedComponent('Recibo de pago');
    };

    const employeePrivilage = user?.idPriv;


    return (
        <div className="recep-main">
            <section className="recep-side-menu main-color" ref={menuRef}>
                <div className={`menu ${menuOpen ? 'active' : ''}`} >
                    <RecepMenu onMenuItemClick={handleMenuItemClick} priv = {employeePrivilage}/> {/* Pasar la función a RecepMenu */}
                </div>
                <div className="side-menu-bar" onClick={handleMenuClick}> <span>{"||>"}</span></div>
            </section>
            <section className="recep-contain background-img">
                {renderSelectedComponent()} {/* Renderiza el componente seleccionado */}
            </section>
            <ConfirmModal
                isOpen={isModalConfirmOpen}
                handleAccept={modalHandlers.handleAccept}
                handleCancel={modalHandlers.handleCancel}
                text={modalDetailAction}
                title={modalTitleAction}
                continueButtonText="Realizar ahora"
            />
        </div>
    );
}

export default Reception;
